/*
 *
 *  remotes
 *
 */

import api from '../../helpers/Api'
//import constantName from './key'



/**
 * 
 * @param {string} metaData 
 * @returns 
 */

export function loadRecordsMetaData(metaData, method) {
    if (method === "post") {
      return api
        .post(`/get_all_${metaData}`)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error))
    } else {
      return api
        .get(`/get_all_${metaData}`)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error))
    }
  }


  // permission details 
    export async function loadMyHighValueLeadApi(searchvalue){
      if (searchvalue) {
        return await api
          .post(`/get_high_value_lead`, searchvalue)
          .then((response) => response.data)
          .catch((error) => Promise.reject(error))
      } else {
     return await api.post(`/get_high_value_lead`)
      .then((response)=>response.data)
      .catch((error)=>Promise.reject(error))
    }
  }


  export  function addFollowUpAPI(followupValues) {
    return  api
      .post(`/add_lead_followup`, followupValues)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
  
export  function updateSubStatusAPI(subStatusValues) {
  return  api
    .post(`/update_lead_sub_status`, subStatusValues)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}  


export  function updateRejectAPI(rejectValues) {
  return  api
    .put(`/update_rejectreason_by_id`, rejectValues)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


export async function loadRecordsAttachmentDetailData() {
  try {
    const response = await api.get(
      `/get_all_call_upload`
    )
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}


export async function uploadFollowupAttachmentRecordData(record) {
  try {
    console.log("recordrecord", record)
    const response = await api.put(
      `/update_by_call_upload_id`,
      record
    )
    //return response.data
    return Promise.resolve(response.data)

  } catch (error) {
    return Promise.reject(error)
  }
}

const remotes = {
   
    loadRecordsMetaData,
    loadMyHighValueLeadApi,
    addFollowUpAPI,
    updateSubStatusAPI,
    updateRejectAPI,
    loadRecordsAttachmentDetailData,
    uploadFollowupAttachmentRecordData

}

export default remotes
